// extracted by mini-css-extract-plugin
module.exports = {"container":"Share_container__2G9cf","header":"Share_header__2ARSJ","title":"Share_title__3XklX","close":"Share_close__YHuBK","content":"Share_content__20F3k"};